import { SingleQuestionAnalytics } from 'api/analytics/types';
import { TableColumn } from 'types/table';
import { Modal } from '../../ui/Modal';
import Table from '../../ui/Table';
import QuestionAnalyticsChart from '../charts/QuestionAnalyticsChart';

interface Props {
  data: SingleQuestionAnalytics;
  onClose: () => void;
}

export const QuestionAnalytics = ({ data, onClose }: Props) => {
  const columns: TableColumn[] = [
    {
      key: 'total',
      name: 'Total Answered',
      align: 'center',
      cell: (el) => el.statistics.totalAnswered
    },
    {
      key: 'correct',
      name: 'Correct',
      align: 'center',
      cell: (el) => el.statistics.totalCorrect
    },
    {
      key: 'wrong',
      name: 'Incorrect',
      align: 'center',
      cell: (el) => el.statistics.totalAnswered - el.statistics.totalCorrect
    },
    {
      key: 'percent',
      name: 'Percentage correct',
      align: 'center',
      cell: (el) => Math.round((el.statistics.totalCorrect * 100.0) / el.statistics.totalAnswered || 0) + '%'
    }
  ];

  return (
    <Modal title="Question Analytics" onClose={onClose} boxClassName="w-[800px]">
      <Table isLoading={false} data={[data]} columns={columns} className="questionAnalyticsTable" />
      <div className="h-[400px] my-16">
        <QuestionAnalyticsChart history={data.statistics.history}/>
      </div>
    </Modal>
  );
};
